module.exports = __webpack_public_path__ + "static/media/bid-cart.63d49eed.svg";